import React, { FC } from 'react';
import { InfoSectionProps } from './props';
import './styles.scss';

export const InfoSection: FC<InfoSectionProps> = ({ onInfoIconClick }) => {
  return (
    <div className="featured-applicants-info-section">
      <div className="featured-applicants-info-section__text">
        <div className="featured-applicants-info-section__title">
          <h3>
            <span>Passive search.</span> Where Talent wants to be Found.
          </h3>
        </div>

        <p>
          Passive search candidates have shared their profile with you for a review. They want companies to review them
          and <br /> get in touch. This platform is where they wait for the right opportunity to start something
          new.&nbsp;
          <span className="featured-applicants-info-section__learn_more" onClick={onInfoIconClick}>
            Learn more.
          </span>
        </p>
      </div>
    </div>
  );
};
